import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  DefinitionListComponent,
  DefinitionListValueDirective,
} from '@libs/ui';
import { TranslateModule } from '@ngx-translate/core';
import { AnalysisConfigurationSummary } from './analysis-configuration-summary.model';

@Component({
  selector: 'pm-analysis-configuration-summary',
  templateUrl: './analysis-configuration-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    DefinitionListComponent,
    DefinitionListValueDirective,
  ],
})
export class AnalysisConfigurationSummaryComponent {
  public readonly summary = input.required<AnalysisConfigurationSummary>();
}
